import { render, staticRenderFns } from "./transverseAside.vue?vue&type=template&id=ca9d8466&scoped=true"
import script from "./transverseAside.vue?vue&type=script&lang=js"
export * from "./transverseAside.vue?vue&type=script&lang=js"
import style0 from "./transverseAside.vue?vue&type=style&index=0&id=ca9d8466&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d8466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca9d8466')) {
      api.createRecord('ca9d8466', component.options)
    } else {
      api.reload('ca9d8466', component.options)
    }
    module.hot.accept("./transverseAside.vue?vue&type=template&id=ca9d8466&scoped=true", function () {
      api.rerender('ca9d8466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/component/transverseAside.vue"
export default component.exports